import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { c as _ } from "./Section-DOeCOW54.js";
import o from "react";
import { P as m } from "./Picture-JvtjNict.js";
import { T as r } from "./useMediaQuery-BZAMobKw.js";
const i = {
  "building-card": "elo-building-card",
  "building-card__image-wrapper": "elo-building-card__image-wrapper",
  "building-card__image-wrapper__overlay": "elo-building-card__image-wrapper__overlay",
  "building-card__image": "elo-building-card__image",
  "building-card__large": "elo-building-card__large",
  "building-card__small": "elo-building-card__small",
  "building-card__chip": "elo-building-card__chip",
  "building-card__text-wrapper": "elo-building-card__text-wrapper",
  "building-card__subtext": "elo-building-card__subtext",
  "building-card__title": "elo-building-card__title",
  "building-card__overlay": "elo-building-card__overlay"
}, v = o.forwardRef(({ url: c, image: d, size: g, tagText: n, title: l, subtitle: u, onClick: t, wrapperClassName: s, ...b }, p) => /* @__PURE__ */ e(
  "a",
  {
    ref: p,
    href: c,
    className: _(
      i["building-card"],
      i[`building-card__${g}`],
      s
    ),
    onClick: t,
    ...b,
    children: [
      /* @__PURE__ */ a("div", { className: i["building-card__overlay"] }),
      /* @__PURE__ */ a(
        m,
        {
          src: [
            {
              src: d,
              media: "(min-width:320px)"
            }
          ],
          defaultSrc: d,
          alt: l,
          zoom: !0,
          wrapperClassName: i["building-card__image-wrapper"],
          className: i["building-card__image"]
        }
      ),
      /* @__PURE__ */ a(
        r,
        {
          type: "span",
          size: "mediumBold",
          extraClass: i["building-card__chip"],
          children: n
        }
      ),
      /* @__PURE__ */ e("div", { className: i["building-card__text-wrapper"], children: [
        /* @__PURE__ */ a(
          r,
          {
            type: "heading",
            size: "xsmall",
            extraClass: _(
              i["building-card__subtext"],
              i["building-card__title"]
            ),
            children: l
          }
        ),
        /* @__PURE__ */ a(
          r,
          {
            type: "paragraph",
            size: "medium",
            extraClass: i["building-card__subtext"],
            children: u
          }
        )
      ] })
    ]
  }
));
export {
  v as B
};
